import { Route, Routes, useNavigate} from 'react-router-dom';
import { StandardViewPanel } from '../../../_components/panel/standardView.panel';
import { getDateString } from '../../../_helpers/dateTime.helper';
import { ClientMedicalInfoManageDrawer } from './client-medicalInfoManageDrawer';

export const ClientMedicalInfoPanel = ({ data, isLoading, onRefresh }: any) => {

    const navigate = useNavigate();

    const rows = [
        { label: 'Medical Card No.', value: data.medicalCardNo },
        { label: 'Medical Card Expiry', value: data.medicalCardExpiry ? getDateString(data.medicalCardExpiry) : "" },
        { label: 'Allergies', value: data.allergies },
    ]

    return (
        <>
            <StandardViewPanel
                title="Medical Info" buttons={[
                    { icon: "edit", onClick: () => { navigate("ManageMedicalInfo/") } }
                ]} 
                loading={isLoading}
                items={rows} />
            <Routes>
                <Route path="ManageMedicalInfo/" element={<ClientMedicalInfoManageDrawer onSave={() => { navigate(""); onRefresh(); }} onClose={() => { navigate(""); onRefresh(); }} />} />
            </Routes>
        </>
    );
};